import React from 'react';
import Context from './context';
import Title from './Title';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import AppTypography from '../../core/Typography/AppTypography';
import Button from '@material-ui/core/Button';
import { COVID_19_NEWS } from '../variables';
import MaskImage from '../../../images/features/jtb/mask.png';
import FlowImage from '../../../images/features/jtb/flow.png';

const Flow = () => {
  const { classes } = React.useContext(Context);

  return (
    <div>
      <Title>
        おてつたびとJTB
        <br />
        コラボの流れ
      </Title>
      <Box pt={10}>
        <Grid container className={classes.flowGrid} spacing={2}>
          <Grid item xs={12} sm={6} md={5}>
            <AppTypography lineHeight={1.8} my={2.5} color="textPrimary">
              現在、ふるさと納税は寄附額が拡大する一方で、返礼品の出品事業者である一次産業従事者の人手不足が年々深刻になっています。
            </AppTypography>
            <AppTypography
              lineHeight={1.8}
              mb={{ xs: 2.5, sm: 5 }}
              color="textPrimary"
            >
              ふるさと納税の本来の目的である”地域を大切にしてくれる想いを繋ぐ”ということを再確認するために、おてつたびを通じて様々な地域を訪れることで、
              人手不足を解消すると共に、より地域の魅力を再発見しながら地域のファンが増えるような取り組みを実施していきます！
            </AppTypography>
            <Button
              variant="contained"
              href={COVID_19_NEWS}
              className={classes.announcementButton}
            >
              <span className="wrapper">
                <img src={MaskImage} className="mask" />
                <span>新型コロナウイルス感染予防のためのご協力のお願い</span>
              </span>
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} md={7} className={classes.flowImageGrid}>
            <img src={FlowImage} />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default Flow;
